import React from 'react';
import { Avatar } from 'components/common';
const AuthorRenderer = (params) => {
  const {author: topic} = params.data;
  
  return (
   <div className="tw-flex tw-items-center tw-my-2"> 
    <Avatar 
        src={topic?.avatar} 
        name={topic?.name}
        size="l" 
        className="tw-mr-3 tw-shrink-0" 
      />
    </div>
  )
}

export default AuthorRenderer;